import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServicesResult} from './citizens-services-result.model';
import * as CitizensServicesResultActions from './citizens-services-result.actions';

export const citizensServicesResultsFeatureKey = 'citizensServicesResults';

export interface State extends EntityState<CitizensServicesResult> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesResult> = createEntityAdapter<CitizensServicesResult>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesResultActions.addCitizensServicesResult,
    (state, action) => adapter.addOne(action.citizensServicesResult, state)
  ),
  on(CitizensServicesResultActions.upsertCitizensServicesResult,
    (state, action) => adapter.upsertOne(action.citizensServicesResult, state)
  ),
  on(CitizensServicesResultActions.addCitizensServicesResults,
    (state, action) => adapter.addMany(action.citizensServicesResults, state)
  ),
  on(CitizensServicesResultActions.upsertCitizensServicesResults,
    (state, action) => adapter.upsertMany(action.citizensServicesResults, state)
  ),
  on(CitizensServicesResultActions.updateCitizensServicesResult,
    (state, action) => adapter.updateOne(action.citizensServicesResult, state)
  ),
  on(CitizensServicesResultActions.updateCitizensServicesResults,
    (state, action) => adapter.updateMany(action.citizensServicesResults, state)
  ),
  on(CitizensServicesResultActions.deleteCitizensServicesResult,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesResultActions.deleteCitizensServicesResults,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesResultActions.loadCitizensServicesResults,
    (state, action) => adapter.setAll(action.citizensServicesResults, state)
  ),
  on(CitizensServicesResultActions.clearCitizensServicesResults,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
